export const seniorEmbeddedEngineerResume = `
【職務概要】
私は組み込みソフトウェア開発の分野で15年以上の経験を持つエンジニアです。主に産業機器、自動車関連システム、および防衛分野における組み込みシステムの設計・開発に携わってきました。C/C++言語を中心としたリアルタイムOSベースの開発に精通し、マイコン制御からFPGA、通信プロトコル実装まで幅広い技術領域をカバーしています。

近年ではIoT技術の進展に伴い、センサーデータ活用や機械学習を組み込んだインテリジェントなシステム開発にも注力しています。プロジェクトリーダーとして5〜15名規模のチームマネジメントを担当し、要件定義から製品リリースまでの全工程を主導した経験を多数有します。特にミッションクリティカルなシステムにおける高信頼性ソフトウェア開発のノウハウと、ハードウェアとソフトウェアの境界領域に関する深い知見を強みとしています。

【職務経歴】
○ 株式会社Algomaticエレクトロニクス（2014年4月〜現在）
・会社概要：産業機器、防衛システム、IoTデバイスの開発・製造を行う電子機器メーカー（従業員約850名）
・就業期間：2014年4月〜現在
・職務内容：
  1. 組込みソフトウェア開発部 チーフエンジニア（2020年4月〜現在）
     - 防衛分野のレーダーシステム向け組込みソフトウェアの設計・開発プロジェクトのリーダー
     - 信号処理アルゴリズムの開発と最適化
     - リアルタイムOS上でのマルチタスク処理設計
     - 外部ベンダーとの協業による開発プロセス管理
  2. 組込みソフトウェア開発部 シニアエンジニア（2014年4月〜2020年3月）
     - 産業機器向けセンサーネットワークシステムの開発
     - 通信プロトコル（CAN、Ethernet、RS-485等）の実装
     - ファームウェア更新システムの構築
・具体的な成果：
  - レーダーシステム処理速度の30%向上を実現し、顧客から高評価を獲得
  - ソフトウェア開発プロセスの改善により、バグ発生率を40%低減
  - コードレビュープロセスを確立し、チーム全体の技術力向上に貢献
・使用技術：C/C++、アセンブラ、RTOS（VxWorks、FreeRTOS）、FPGA（VHDL）、DSP、ARM Cortex-M/A、CAN/UART/SPI/I2C通信
・習得スキル：大規模組込みシステムの設計手法、防衛システム開発における品質保証プロセス、チームマネジメント

○ 株式会社Algomaticテクノロジーズ（2009年7月〜2014年3月）
・会社概要：自動車関連電子システム、家電製品の組込みソフトウェア開発企業（従業員約450名）
・就業期間：2009年7月〜2014年3月
・職務内容：
  1. 車載システム開発グループ エンジニア
     - エンジン制御ユニット（ECU）のファームウェア開発
     - 車載ネットワーク（CAN、LIN、FlexRay）の通信制御ソフトウェア開発
     - 自動車メーカー向けカスタムソリューションの提案・実装
・具体的な成果：
  - 燃費最適化アルゴリズムの改良により、従来比5％の燃費向上を実現
  - AUTOSAR準拠の開発手法を導入し、コンポーネント再利用率を65%に向上
  - 新人エンジニア5名の技術指導を担当し、全員を1年以内に戦力化
・使用技術：C言語、MATLAB/Simulink、AUTOSAR、CAN/LIN通信、車載マイコン（RH850、SH-2A）
・習得スキル：車載システム開発手法、モデルベース開発、リアルタイム制御技術

○ 株式会社Algomatic産業システム（2006年4月〜2009年6月）
・会社概要：工場自動化システム、制御機器の開発・製造メーカー（従業員約280名）
・就業期間：2006年4月〜2009年6月
・職務内容：
  1. 組込みソフトウェア開発部 エンジニア
     - 製造ライン制御システムの組込みソフトウェア開発
     - センサーデータ収集・処理システムの設計・実装
     - PLCとの連携インターフェース開発
・具体的な成果：
  - 工場内無線センサーネットワークの構築により、データ収集工数を70%削減
  - ソフトウェア設計の標準化により、新規プロジェクトの立ち上げ期間を3週間短縮
・使用技術：C/C++、Linux、マイコン（PIC、AVR）、無線通信（ZigBee、Bluetooth）
・習得スキル：制御系ソフトウェア開発、センサーネットワーク構築、低消費電力設計

【受賞・表彰歴】
・2023年 株式会社Algomaticエレクトロニクス 社長賞（防衛システム開発における技術革新）
・2021年 技術イノベーション賞（センサーフュージョン技術の実用化）
・2018年 エンベデッドシステムシンポジウム 優秀論文賞（「リアルタイム組込みシステムにおける省電力化手法」）
・2016年 プロジェクト功労賞（産業用IoTプラットフォーム構築）

【資格】
・情報処理技術者試験 システムアーキテクト（2017年4月）
・組込みシステムスペシャリスト（2012年10月）
・ETEC クラスA（2011年3月）
・情報処理技術者試験 ネットワークスペシャリスト（2015年10月）
・TOEIC 820点（2021年6月）

【マネジメント経験】
・プロジェクトマネージャーとして最大15名のチームをリード（2019年〜現在）
・若手エンジニア育成プログラムの策定・実施（延べ20名の指導実績）
・技術部門の品質改善ワーキンググループリーダー（2018年〜2020年）
・成果：メンバーの技術スキル向上により、プロジェクト納期遵守率98%達成
・社内技術勉強会の企画・運営（月1回、参加者平均25名）

【語学力】
・英語：ビジネスレベル（TOEIC 820点）
  ○ 海外ベンダーとの技術ミーティング、仕様書作成
  ○ 国際カンファレンスでの技術発表経験あり
・中国語：基礎レベル（簡単な日常会話）
` as const;
